import classNames from 'classnames';
import clsx from 'clsx';
import { ButtonHTMLAttributes, DetailedHTMLProps, ReactElement, SVGProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';

interface ButtonProps extends DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  isCompact?: boolean;
  Icon: (props: SVGProps<SVGSVGElement>) => ReactElement;
  title: string;
  additionalClassName?: string;
  haveBadge?: boolean;
  badgeContent?: string;
}

export const GPTGameButton = ({
  Icon,
  title,
  isCompact = false,
  additionalClassName,
  haveBadge,
  badgeContent,
  ...props
}: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <Button
      mode="button-primary"
      className={clsx(
        additionalClassName,
        'relative flex !max-w-full w-full items-center justify-center gap-2 overflow-hidden rounded-lg transition-all duration-150'
      )}
      title={t(title)}
      {...props}>
      <Icon className={classNames('max-h-6 max-w-6')} />
      <div className="flex-1 flex justify-between items-center">
        <div className="flex flex-1 items-center justify-between">
          <p className="text-left text-sm font-bold">{t(title)}</p>
        </div>
        {haveBadge && (
          <div className="flex justify-center items-center py-1 px-2 text-xs font-medium rounded-[20px]">
            {t(badgeContent ?? '')}
          </div>
        )}
      </div>
    </Button>
  );
};
